@if (formGroup) {
  <div
    (cdkDropListDropped)="onDrop($event)"
    [cdkDropListConnectedTo]="connectedDropLists"
    [cdkDropListData]="formGroup.value.children"
    [class.column-layout]="layout === 'column'"
    [class.root-level]="isRootLevel"
    [formGroup]="formGroup"
    cdkDropList
    class="logical-query-container"
  >
    @for (
      control of formGroup.controls.children.controls;
      track control;
      let first = $first;
      let index = $index
    ) {
      <div class="flex flex-col gap-8 w-full">
        <div
          (cdkDragEntered)="onDragEntered($event)"
          (cdkDragStarted)="onDragStarted($event)"
          [cdkDragData]="control"
          [cdkDragDisabled]="!isInOrganizeMode || disabled"
          [class.items-baseline]="layout === 'column'"
          [class.items-center]="layout === 'row'"
          cdkDrag
          class="flex gap-8 w-full flex-1 justify-center"
        >
          @if (isInOrganizeMode) {
            <div>
              <button cdkDragHandle type="button" class="drag-handle">
                <mat-icon svgIcon="icon_drag_16" />
              </button>
            </div>
          }
          <div class="tag-container">
            @if (first) {
              <div class="tag tag-primary">When</div>
            } @else {
              <div class="tag">
                @if (index === 1) {
                  <div
                    (click)="toggleLogicalType(formGroup)"
                    class="logical-type-tag cursor-pointer"
                    data-cy="ComplexFilter:LogicalTypeTag"
                  >
                    {{ logicalType }}
                  </div>
                }
                @if (index > 1) {
                  <div
                    [class.greyed-out]="index > 1"
                    class="logical-type-tag greyed-out"
                    data-cy="ComplexFilter:LogicalTypeTag"
                  >
                    {{ logicalType }}
                  </div>
                }
              </div>
            }
          </div>

          @if (isLogicalQueryRow(control)) {
            <blaze-logical-query-row
              (delete)="delete.emit($event)"
              (itemDrop)="onChildDrop($event)"
              [disabled]="disabled"
              [formGroup]="control"
              [isInOrganizeMode]="isInOrganizeMode"
              [layout]="layout"
              [level]="level + 1"
              [useAppTheme]="useAppTheme"
              data-cy="ComplexFilter:LogicalQueryRow"
            />
          }
          @if (isComparisonQueryRow(control)) {
            <blaze-comparison-query-row
              (operatorUpdate)="onComparisonRowOperatorUpdate($event, control)"
              [disabled]="disabled"
              [formGroup]="control"
              [isInOrganizeMode]="isInOrganizeMode"
              [layout]="layout"
              [level]="level"
              [useAppTheme]="useAppTheme"
              data-cy="ComplexFilter:ComparisonQueryRow"
            />
          }
          <!-- TODO: remove $any !-->
          <ng-container [formGroup]="$any(control)">
            @if (isInOrganizeMode) {
              <div class="checkbox-container">
                <blaze-checkbox
                  formControlName="selected"
                  data-cy="ComplexFilter:SelectionCheckbox"
                />
              </div>
            } @else {
              <div
                class="flex gap-8 items-center"
                [style.padding-top.px]="isLogicalQueryRow(control) ? 9 : 0"
              >
                @if (!disabled && !isLogicalQueryRow(control) && showIgnoreWhenEmptyToggle()) {
                  <mat-slide-toggle
                    [class.invisible]="hideIgnoreWhenEmptyToggles()[control.value.formControlId]"
                    blazeTooltip="Don't include when empty"
                    class="bd-toggle overflow-hidden"
                    formControlName="isOptional"
                    matTooltipPosition="above"
                    matTooltipShowDelay="0"
                  />
                }
                @if (!disabled) {
                  <button
                    (click)="delete.emit(control)"
                    blazeClickable
                    class="btn-icon"
                    data-cy="ComplexFilter:DeleteBtn"
                    type="button"
                  >
                    <mat-icon svgIcon="icon_trash_16" />
                  </button>
                }
              </div>
            }
          </ng-container>
        </div>
      </div>
    }
  </div>
}
